import { Navigate, useNavigate } from 'react-router-dom'
import { signedInAsSelector, userModuleSelector } from 'domain/User/selectors'
import { Button } from 'antd'
import Heading from 'components/Heading'
import { MODULES } from 'constants/modules'
import paths from 'constants/paths'
import React from 'react'
import Text from 'components/Text'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import './pageNotFound.less'

const PageNotFound = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const signedInAs = useSelector(signedInAsSelector)
  const userModule = useSelector(userModuleSelector)

  const hasAnyModule =
    userModule?.includes(MODULES.CARGOMATE) || userModule?.includes(MODULES.ROB)

  if (signedInAs && !hasAnyModule) {
    return <Navigate replace to={paths.noModuleAccess} />
  }

  return (
    <div className="page-not-found__container">
      <Heading isDark level={1}>
        {t('pageNotFound.theKrakenHasSunkThisPage')}
      </Heading>

      <div className="page-not-found__body-container">
        <Text>{t('pageNotFound.backToSafety')}</Text>
        <Button
          className="page-not-found__overview-link"
          type="link"
          onClick={() => {
            navigate(paths.overview)
          }}
        >
          {t('pageNotFound.overviewPage')}
        </Button>
      </div>
    </div>
  )
}

export default PageNotFound
